export default "/images/icon-compare.png";